var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5675 8.9625L11.82 9.4275L10.32 8.58V6.42L11.82 5.5725L13.5675 6.0375L13.9575 4.59L12.63 4.2375L12.975 2.91L11.5275 2.52L11.0625 4.2675L9.5625 5.115L7.725 4.035V2.34L9.0075 1.0575L7.9425 0L6.975 0.9675L6.0075 0L4.9425 1.0575L6.225 2.34V4.035L4.35 5.115L2.85 4.2675L2.415 2.52L0.975 2.91L1.3275 4.2375L0 4.59L0.39 6.0375L2.1375 5.5725L3.6375 6.42V8.5875L2.1375 9.435L0.39 8.97L0 10.4175L1.3275 10.77L0.975 12.09L2.4225 12.48L2.8875 10.7325L4.3875 9.885L6.225 10.965V12.66L4.9425 13.9425L6.0075 15L6.975 14.0325L7.9425 15L9 13.9425L7.725 12.66V10.965L9.6 9.8775L11.1 10.725L11.565 12.4725L12.975 12.09L12.6225 10.7625L13.95 10.41L13.5675 8.9625ZM5.1 6.42L6.975 5.3325L8.85 6.42V8.58L6.975 9.6675L5.1 8.58V6.42Z",
    fill: "#1B4C84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCold);
export default __webpack_public_path__ + "static/media/cold.0e7554212bd56d6d1235c4f728e8fab9.svg";
export { ForwardRef as ReactComponent };